import React, { useContext, useEffect, useState } from "react";
import {
    get_rawtransaction,
    getUnits,
    create_rawtransection,
    postGeneralData,
    // delete_rawtransaction
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate, getFormattedCurrentDate2, getStoredEntriesPerPage } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation } from "react-router-dom";
import { EditRawTransection } from "./rtransfrm";

function Raw_transection() {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader, UserItem, shopItem, warehouse, parentCompany } = useContext(WarehouseContext);

    const [rawmaterials, setRawmaterials] = useState([]);
    const [selectedRaw, setSelectedRaw] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);
    const [transactionType, setTransactionType] = useState("1");
    const [preSelectedMaterial, setPreSelectedMaterial] = useState(null);
    const [viewType, setViewType] = useState("add"); // "add" or "taken"
    const [activeTab, setActiveTab] = useState("raw"); // "raw" or "1"

    // Take Modal State
    const [showTakeModal, setShowTakeModal] = useState(false);
    const [selectedTakeItem, setSelectedTakeItem] = useState(null);
    const [takeFormData, setTakeFormData] = useState({
        date: new Date().toISOString().split("T")[0],
        taken_by: "",
        qty: "",
        price: "",
        remarks: ""
    });
    const [takeFormErrors, setTakeFormErrors] = useState({});

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(getStoredEntriesPerPage(10));
    const [searchText, setSearchText] = useState("");
    const [unitsList, setUnitsList] = useState([]);

    useEffect(() => {
        fetchRawmaterials(1, searchText, viewType, activeTab, entriesPerPage);
    }, [viewType, activeTab, entriesPerPage]);

    useEffect(() => {
        fetchUnitsList();
    }, []);

    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        if (String(unitId).toLowerCase() === "li") return "li";
        return unitId;
    };

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchRawmaterials = async (page = 1, text = searchText, currentViewType = viewType, currentTab = activeTab, limit = entriesPerPage) => {
        showLoader();
        try {
            const addTakenParam = currentViewType === "add" ? "1" : "0";
            const response = await get_rawtransaction(page, limit, text, addTakenParam, currentTab);
            if (response.data && response.data.data) {
                setRawmaterials(response.data.data);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };

    const openAddModal = (type = "1", material = null) => {
        setAddOrEdit(true);
        setSelectedRaw(null);
        setTransactionType(type);
        setPreSelectedMaterial(material);
        setShowEditModal(true);
    };

    const openEditModal = (raw) => {
        setSelectedRaw(raw);
        setAddOrEdit(false);
        setPreSelectedMaterial(null);
        setShowEditModal(true);
    };

    const handleOpenTakeModal = (raw) => {
        setSelectedTakeItem(raw);
        const loggedInName = UserItem?.name || UserItem?.full_name || UserItem?.username || UserItem?.first_name || UserItem?.user_name || "Admin User";
        setTakeFormData({
            date: new Date().toISOString().split("T")[0],
            taken_by: loggedInName,
            qty: "",
            price: "",
            remarks: ""
        });
        setTakeFormErrors({});
        setShowTakeModal(true);
    };

    const handleTakeQtyChange = (e) => {
        const qtyVal = e.target.value;
        let autoPrice = takeFormData.price;

        if (qtyVal && !isNaN(qtyVal) && selectedTakeItem) {
            const batchPrice = parseFloat(selectedTakeItem.price || 0);
            const batchQty = parseFloat(selectedTakeItem.qty || 1);
            if (batchQty > 0) {
                const unitPrice = batchPrice / batchQty;
                autoPrice = (unitPrice * parseFloat(qtyVal)).toFixed(2);
            }
        }

        setTakeFormData(prev => ({
            ...prev,
            qty: qtyVal,
            price: autoPrice
        }));

        if (takeFormErrors.qty) {
            setTakeFormErrors(prev => ({ ...prev, qty: "" }));
        }
    };

    const handleTakeSubmit = async (e) => {
        e.preventDefault();

        const qtyNum = parseFloat(takeFormData.qty);
        const availableNum = parseFloat(selectedTakeItem?.remaining || 0);
        const unitName = selectedTakeItem?.type == "2" ? "li" : getUnitName(selectedTakeItem?.unit_id);

        if (!takeFormData.qty || isNaN(qtyNum) || qtyNum <= 0) {
            toast.error("Please enter a valid quantity");
            return;
        }

        if (qtyNum > availableNum) {
            toast.error(`Quantity cannot be greater than available stock (${availableNum.toFixed(2)} ${unitName})`);
            return;
        }

        showLoader();

        try {
            const shop_id = parseInt(shopItem?.id || localStorage.getItem("shop_id") || "0");
            const warehouse_id = parseInt(warehouse?.id || localStorage.getItem("warehouse_id") || "0");
            const branch_id = parseInt(parentCompany?.id || localStorage.getItem("branch_id") || "0");
            const user_id = parseInt(UserItem?.user_id || "0");

            const takePrice = parseFloat(takeFormData.price || 0);

            const payload = {
                data: [{
                    raw_mat_id: parseInt(selectedTakeItem.raw_mat_id || selectedTakeItem.id),
                    qty: qtyNum,
                    add_taken: "0",
                    unit_id: selectedTakeItem.unit_id,
                    supplier_id: selectedTakeItem.supplier_id ? parseInt(selectedTakeItem.supplier_id) : null,
                    price: takePrice,
                    price_unit: selectedTakeItem.price_unit ? parseFloat(selectedTakeItem.price_unit) : (qtyNum > 0 ? takePrice / qtyNum : 0),
                    warehouse_id: warehouse_id,
                    shop_id: shop_id,
                    branch_id: branch_id,
                    created_by: user_id,
                    transaction_id: selectedTakeItem.transaction_id || "",
                    expdate: takeFormData.date || selectedTakeItem.expdate || "",
                    mfgdate: selectedTakeItem.mfgdate || "",
                    remarks: takeFormData.remarks || `Stock taken by ${takeFormData.taken_by}`,
                    payment_status: "cash",
                    payment_remaining: "0"
                }]
            };

            const response = await create_rawtransection(payload);

            if (response?.data?.status === "success") {
                try {
                    // Post General Ledger accounting entries for Trial Balance & Accounts
                    const generalDataPayload = {
                        type: "3",
                        ref_id: String(selectedTakeItem.raw_mat_id || selectedTakeItem.id),
                        remarks: `Raw Material Taken - ${selectedTakeItem.title} by ${takeFormData.taken_by}`,
                        date: takeFormData.date || getFormattedCurrentDate2(),
                        created_by: String(user_id),
                        shop_id: String(shop_id),
                        amount: String(takePrice),
                        is_debit: "0",
                    };
                    await postGeneralData(generalDataPayload);

                    const generalDataPayload1 = {
                        type: "1",
                        ref_id: String(selectedTakeItem.raw_mat_id || selectedTakeItem.id),
                        remarks: `Raw Material Consumption Expense - ${selectedTakeItem.title}`,
                        date: takeFormData.date || getFormattedCurrentDate2(),
                        created_by: String(user_id),
                        shop_id: String(shop_id),
                        amount: String(takePrice),
                        is_debit: "1",
                    };
                    await postGeneralData(generalDataPayload1);
                } catch (e) {
                    console.error("Error saving general data for take stock:", e);
                }

                toast.success("Stock taken successfully");
                setShowTakeModal(false);
                fetchRawmaterials(currentPage, searchText, viewType, activeTab);
            } else {
                toast.error(response?.data?.message || "Error processing stock take");
            }
        } catch (error) {
            console.error("Error taking raw material stock:", error);
            toast.error("Failed to take stock");
        } finally {
            hideLoader();
        }
    };

    const handleDelete = async () => {
        // if (!deleteID) {
        //     toast.error("No raw material selected to delete");
        //     return;
        // }

        // try {
        //     await delete_rawtransaction(deleteID);
        //     showDeletemodel(false);
        //     toast.success("Raw material deleted");
        //     fetchRawmaterials(currentPage);
        // } catch (error) {
        //     console.error("Error deleting raw material:", error);
        //     toast.error("Error deleting raw material");
        // }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchRawmaterials(pageNumber, searchText, viewType, activeTab, entriesPerPage);
    };


    const handleSearch = async (text) => {
        setSearchText(text); // save current search
        fetchRawmaterials(1, text, viewType, activeTab, entriesPerPage);
        setCurrentPage(1);
    };

    const handleViewTypeChange = (type) => {
        setViewType(type);
        setCurrentPage(1);
        fetchRawmaterials(1, searchText, type, activeTab, entriesPerPage);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
        fetchRawmaterials(1, searchText, viewType, tab, entriesPerPage);
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        {activeTab === "1" ? "Packaging Transaction List" : "Raw Transaction List"}
                    </h6>
                    {!readonly && (
                        <div>
                            {/* <button
                                type="button"
                                onClick={() => openAddModal("1")}
                                className="btn btn-success mb-0 me-2"
                                style={{ fontFamily: "poppins" }}
                            >
                                Add New Stock
                            </button> */}
                            {/* <button
                                type="button"
                                onClick={() => openAddModal("0")}
                                className="btn btn-warning mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                Take Stock
                            </button> */}
                        </div>
                    )}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        {/* Material Type Tabs */}
                        <ul className="nav nav-tabs nav-primary mb-3" style={{ fontFamily: "poppins" }}>
                            <li className="nav-item">
                                <button
                                    type="button"
                                    className={`nav-link ${activeTab === "raw" ? "active fw-bold" : ""}`}
                                    onClick={() => handleTabChange("raw")}
                                    style={{ cursor: "pointer" }}
                                >
                                    Raw Materials
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    type="button"
                                    className={`nav-link ${activeTab === "1" ? "active fw-bold" : ""}`}
                                    onClick={() => handleTabChange("1")}
                                    style={{ cursor: "pointer" }}
                                >
                                    Packaging Materials
                                </button>
                            </li>
                        </ul>
                        <div className="row mb-3 align-items-center">
                            <div className="col-12 col-md-6 col-lg-4">
                                <div
                                    className="d-flex position-relative"
                                    style={{ width: "100%" }}
                                >
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: "18px",
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-8 text-end">
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
                                    onClick={() => handleViewTypeChange("add")}
                                >
                                    Add List
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm ${viewType === "taken" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => handleViewTypeChange("taken")}
                                >
                                    Taken List
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Date</th>
                                        <th>Supplier</th>
                                        <th>Title</th>
                                        <th>Price (INR)</th>
                                        <th>{viewType === "add" ? "Total Qty" : "Taken Qty"}</th>
                                        {viewType === "add" && <th>Remaining</th>}
                                        {viewType === "add" && <th className="text-center">Action</th>}
                                        {/* {viewType === "taken" && <th>Date</th>} */}
                                        {/* {!readonly && viewType === "add" && <th>Actions</th>} */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rawmaterials.map((raw, index) => (
                                        <tr key={raw.id}>
                                            <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                                            <td>
                                                {new Date(raw.date_time).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })}
                                            </td>
                                            <td>{raw.supplier_name}</td>
                                            <td>{raw.title}</td>
                                            <td>
                                                {raw.price != null ? Number(raw.price).toFixed(2) : "0.00"}
                                            </td>
                                            <td>
                                                {raw.qty != null ? Number(raw.qty).toFixed(2) : "0.00"}{" "} {raw.type == "2" ? "li" : getUnitName(raw.unit_id)}
                                            </td>
                                            {viewType === "add" && <td>{Number(raw.remaining).toFixed(2)}{" "} {raw.type == "2" ? "li" : getUnitName(raw.unit_id)}</td>}
                                            {viewType === "add" && (
                                                <td className="text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary py-0 px-2"
                                                        onClick={() => handleOpenTakeModal(raw)}
                                                        disabled={Number(raw.remaining) <= 0}
                                                        title="Take Stock"
                                                    >
                                                        <i className="bi bi-dash-circle me-1"></i>
                                                        Take
                                                    </button>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                entriesPerPage={entriesPerPage}
                                onEntriesPerPageChange={(val) => {
                                    setEntriesPerPage(val);
                                    setCurrentPage(1);
                                    fetchRawmaterials(1, searchText, viewType, activeTab, val);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Take Stock Modal */}
            {showTakeModal && selectedTakeItem && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title text-white" style={{ fontFamily: "poppins" }}>
                                    <i className="bi bi-box-arrow-right me-2"></i>
                                    Take Raw Material Stock
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => setShowTakeModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ fontFamily: "poppins" }}>
                                <form onSubmit={handleTakeSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Raw Material</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm bg-light"
                                            value={selectedTakeItem.title || ""}
                                            disabled
                                            readOnly
                                        />
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Date</label>
                                            <input
                                                type="date"
                                                name="date"
                                                value={takeFormData.date}
                                                onChange={(e) => setTakeFormData(prev => ({ ...prev, date: e.target.value }))}
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold">Taken By</label>
                                            <input
                                                type="text"
                                                value={takeFormData.taken_by}
                                                className="form-control form-control-sm bg-light"
                                                disabled
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-8">
                                            <label className="form-label fw-bold">Quantity to Take</label>
                                            <input
                                                type="number"
                                                name="qty"
                                                step="any"
                                                placeholder="Enter Quantity"
                                                value={takeFormData.qty}
                                                onChange={handleTakeQtyChange}
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control form-control-sm"
                                            />
                                            <small className="text-muted d-block mt-1">
                                                <i className="bi bi-info-circle me-1"></i>
                                                Available Qty: <strong className="text-primary">{Number(selectedTakeItem.remaining || 0).toFixed(2)} {selectedTakeItem.type == "2" ? "li" : getUnitName(selectedTakeItem.unit_id)}</strong>
                                            </small>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-bold">Unit</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm bg-light"
                                                value={selectedTakeItem.type == "2" ? "li" : getUnitName(selectedTakeItem.unit_id)}
                                                disabled
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Price / Total Cost (INR)</label>
                                        <input
                                            type="number"
                                            name="price"
                                            step="any"
                                            placeholder="Total Cost"
                                            value={takeFormData.price}
                                            onChange={(e) => setTakeFormData(prev => ({ ...prev, price: e.target.value }))}
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control form-control-sm"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Remarks / Notes</label>
                                        <input
                                            type="text"
                                            name="remarks"
                                            placeholder="Enter reason or notes"
                                            value={takeFormData.remarks}
                                            onChange={(e) => setTakeFormData(prev => ({ ...prev, remarks: e.target.value }))}
                                            className="form-control form-control-sm"
                                        />
                                    </div>

                                    <div className="d-flex justify-content-end gap-2 mt-4">
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => setShowTakeModal(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-sm"
                                        >
                                            Save & Take Stock
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            {showEditModal && (
                <EditRawTransection
                    showModal={showEditModal}
                    setShowModal={setShowEditModal}
                    fetchRawmaterials={fetchRawmaterials}
                    selectedRawmaterial={selectedRaw}
                    AddorEdit={addOrEdit}
                    transactionType={transactionType}
                    preSelectedMaterial={preSelectedMaterial}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </div>
    );
}

export default Raw_transection;


